// Shared constants and types
export const STORAGE_KEYS = {
  TIMEZONE: 'userTimezone',
  DAY_START: 'userDayStart',
  DAY_END: 'userDayEnd',
  NAME: 'userName',
  PROACTIVE_FREQUENCY: 'userProactiveFrequency',
  PHONE: 'userPhone',
  IS_SMS_NOTIFICATION_ENABLED: 'isSmsNotificationEnabled',
} as const

export const DEFAULTS = {
  DAY_START: '09:00',
  DAY_END: '17:00',
  PROACTIVE_FREQUENCY: 'off',
} as const

export interface UserPreferences {
  name?: string | null
  timezone?: string | null
  dayStart?: string
  dayEnd?: string
  phone?: string | null
  proactiveFrequency?: string
  isSmsNotificationEnabled?: boolean
}
